export default "__VITE_ASSET__DjT2VocM__"